export const widgetTitle = 'jbp-partnerdevices-title'
export const mifUpdateRequired = 'partnerdevices-mif-update-required'

export const rowLabels = {
  a3DevicesLabel: 'partnerdevices-a3-devices',
  a4DevicesLabel: 'partnerdevices-a4-devices',
  totalMIFLabel: 'partnerdevices-total-mif',
}

export const formFields = {
  allBrandsTitle: 'partnerdevices-all-brands',
  hpBrandTitle: 'partnerdevices-hp-brand',
  hpShareTitle: 'partnerdevices-hp-share',
  partnerContractualSalesHyTitle: 'partnerdevices-partner-contractual-sales-hy',
  addToHpAndTotalSales: 'partnerdevices-add-to-hp-and-total-sales',
}

export const formTooltips = {
  a3PreviousYears: 'jbp-partnerdevices-a3-lt-prev-years',
  a4PreviousYears: 'jbp-partnerdevices-a4-lt-prev-years',
}

export const buttons = {
  mifReviewAndUpdate: 'partnerdevices-mif-review-and-update-button',
  mifReview: 'partnerdevices-mif-review-button',
}
